import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Col } from 'react-bootstrap';
import { map } from 'lodash';
import uuid from 'uuid/v1';

import { getWMSLayerNames } from '../../../api/Layers/layer-operations';

class LayerWMSLayerNamesField extends Component {
  state = {
    selectedLayers: getWMSLayerNames(this.props.layer).split(',')
  };

  componentDidUpdate(prevProps) {
    const { urlIncludesLayers, wmsLayerNames } = this.props;
    const { urlIncludesLayers: prevURLIncludesLayers } = prevProps;
    if (urlIncludesLayers !== prevURLIncludesLayers)
      this.changeSelectedLayers(wmsLayerNames.split(','));
  }

  changeSelectedLayers = newSelectedLayers => this.setState({ selectedLayers: newSelectedLayers });

  searchStyles = event => {
    const { updateShowStyleField, loadWMSStyles } = this.props;
    const { selectedLayers } = this.state;
    updateShowStyleField(selectedLayers.length === 1);
    loadWMSStyles(event);
  };

  selectLayers = event => {
    const { changeLayerEditorStateProperty } = this.props;
    this.changeSelectedLayers(map(event.target.selectedOptions, 'value'));
    changeLayerEditorStateProperty('preselectedStyles', []);
  };

  render() {
    const { wmsLayerTitles, wmsLayerNames, failedFetchDueToCORS } = this.props;
    const { selectedLayers } = this.state;

    const wmsLayers = wmsLayerTitles.split(',');
    const wmsLayersValues = wmsLayerNames.split(',');

    return (
      <Form.Group>
        <Form.Label>Layer Names</Form.Label>
        <Form.Row>
          <Col xs={10}>
            {!failedFetchDueToCORS && (
              <Form.Control
                as="select"
                multiple
                name="layerNamesSelect"
                value={selectedLayers}
                onChange={this.selectLayers}
                placeholder="What's the code name for the layers?"
              >
                {map(wmsLayers, (wmsLayer, index) => (
                  <option key={uuid()} value={wmsLayersValues[index]}>
                    {wmsLayer}
                  </option>
                ))}
              </Form.Control>
            )}
            {failedFetchDueToCORS && (
              <>
                <Form.Control
                  type="text"
                  name="layerNamesInput"
                  defaultValue=""
                  placeholder="What's the code name for the layers?"
                />
                <Form.Text className="text-muted text-break">
                  Enter the layer names separated by commas, no spaces. Example:
                  <br />
                  TN.RailTransportNetwork.RailwayLink,TN.RoadTransportNetwork.RoadLink,TN.AirTransportNetwork.RunwayArea
                </Form.Text>
              </>
            )}
          </Col>
          <Col xs={2}>
            <Button onClick={this.searchStyles}>Search for Styles</Button>
          </Col>
        </Form.Row>
      </Form.Group>
    );
  }
}

LayerWMSLayerNamesField.propTypes = {
  failedFetchDueToCORS: PropTypes.bool.isRequired,
  layer: PropTypes.object.isRequired,
  urlIncludesLayers: PropTypes.bool.isRequired,
  wmsLayerNames: PropTypes.string.isRequired,
  wmsLayerTitles: PropTypes.string.isRequired,
  changeLayerEditorStateProperty: PropTypes.func.isRequired,
  loadWMSStyles: PropTypes.func.isRequired,
  updateShowStyleField: PropTypes.func.isRequired
};

export default LayerWMSLayerNamesField;
